import React, { useState } from 'react';
import './imports.css';
import { Link } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { Alert, Button, Card } from '../ui';
import { RefreshIcon } from '../ui/icons';
import { errorMessage } from '../errors';
import JobProgress from './JobProgress';
import { useJob } from './useJob';
import { cancelJob, fillFromSources } from './importsApi';

/**
 * "Fill from the sources" after a conversion (phase 4 §7): a background job
 * that completes every item of the type from its sources by its source id or
 * its ISBN / EAN, empty fields only; its counts, and the items no source
 * knew or that matched several editions, listed for the owner.
 */
function FillFromSources({ typeId }) {
  const { t } = useTranslation();
  const [started, setStarted] = useState(null);
  const [error, setError] = useState(null);
  const [busy, setBusy] = useState(false);
  const { job } = useJob(started ? started.id : null, started);
  const shown = job || started;
  const start = async () => {
    setBusy(true);
    setError(null);
    try {
      setStarted((await fillFromSources(typeId)).job);
    } catch (e) {
      setError(errorMessage(t, e));
    } finally {
      setBusy(false);
    }
  };
  const result = shown && shown.result;
  return (
    <Card padding="lg" className="fill-sources">
      <h2 className="settings-card__title">{t('fillSources.title')}</h2>
      <p className="settings-card__intro">{t('fillSources.intro')}</p>
      {error && <Alert tone="danger">{error}</Alert>}
      {!shown && <Button icon={RefreshIcon} onClick={start} loading={busy}>{t('fillSources.start')}</Button>}
      {shown && <JobProgress job={shown} label={t('fillSources.label')} onCancel={() => cancelJob(shown.id).catch(() => {})} />}
      {result && shown.status !== 'queued' && (
        <p>{t('fillSources.summary', { filled: result.filled, unchanged: result.unchanged, notFound: result.not_found, ambiguous: result.ambiguous, skipped: result.skipped, failed: result.failed })}</p>
      )}
      {result && result.listed && result.listed.length > 0 && (
        <ul className="import-failed">
          {result.listed.map(entry => (
            <li key={entry.item_id}>
              <Link to={`/c/${entry.inventory_id}/items/${entry.item_id}`}>{entry.title || `#${entry.item_id}`}</Link> — {t(`fillSources.outcome.${entry.outcome}`)}
            </li>
          ))}
        </ul>
      )}
    </Card>
  );
}

export default FillFromSources;
